export default "__VITE_ASSET__CMfqQulH__"